var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBetIconLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 95,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45 7.9 10 26l35 13.4 34.6-16L45 7.9Zm43.2 11.6L45 0 1.3 22.7l-1.3.7v6.5l1.6.6L45 47.2l43-19.9 1-.4v-7l-.8-.4Z",
    fill: "#757575"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52 83.6V44l30-13.3v39L52 83.6Zm-7-44L82 23l7-3.1V74.3l-37 17-2.4 1-4.6 2V39.6Z",
    fill: "#757575"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.6 38.9 0 23.3v57.1l44.3 14.2 4.3-1.8V39Z",
    fill: "#757575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBetIconLight);
export default __webpack_public_path__ + "static/media/bet_icon_light.906957a9a46f9faf840c1ef39ebe9679.svg";
export { ForwardRef as ReactComponent };